import wizard1 from './wizard_1.png';
import wizard2 from './wizard_2.png';
import wizard3 from './wizard_3.png';
import wizard4 from './wizard_4.png';
import wizard5 from './wizard_5.png';
import wizard6 from './wizard_6.png';
import wizard7 from './wizard_7.png';
import wizard8 from './wizard_8.png';
import wizard9 from './wizard_9.png';
import wizard10 from './wizard_10.png';

const wizardAvatars = [
  wizard1, wizard2, wizard3, wizard4, wizard5,
  wizard6, wizard7, wizard8, wizard9, wizard10,
];

/**
 * Get a deterministic default wizard index based on a user identifier.
 */
function defaultWizardIndex(userId) {
  if (!userId) return 0;
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash) + userId.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash) % wizardAvatars.length;
}

/**
 * Get the wizard avatar for a user.
 * If userData has a saved avatarIndex, use that. Otherwise fall back to a hash of the userId.
 */
export function getWizardAvatar(userId, userData) {
  const index = (userData?.avatarIndex != null)
    ? userData.avatarIndex
    : defaultWizardIndex(userId);
  return wizardAvatars[index];
}

/**
 * Get a wizard avatar by its index.
 */
export function getWizardByIndex(index) {
  return wizardAvatars[index % wizardAvatars.length];
}

export default wizardAvatars;
